import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefour-banner',
  templateUrl: './homefour-banner.component.html',
  styleUrls: ['./homefour-banner.component.scss']
})
export class HomefourBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
